/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createFlipbookPagesResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, type ErrorResponse, type FlipbookPagesResponse, type InternalErrorResponse } from '../../../../../../models/index.js';
// @ts-ignore
import { MultipartBody, serializeMultipartBody, type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/flipbooks/{flipbookId}/pages/{pageNumber}/image
 */
export interface ImageRequestBuilder extends BaseRequestBuilder<ImageRequestBuilder> {
    /**
     * Upload a new image (PNG, JPEG, WebP) or a single-page PDF for one page of a flipbook. The page keeps its number and its product tags; only the image changes. The previous image is removed.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<FlipbookPagesResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 404 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     put(body: MultipartBody, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<FlipbookPagesResponse | undefined>;
    /**
     * Upload a new image (PNG, JPEG, WebP) or a single-page PDF for one page of a flipbook. The page keeps its number and its product tags; only the image changes. The previous image is removed.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPutRequestInformation(body: MultipartBody, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const ImageRequestBuilderUriTemplate = "{+baseurl}/api/flipbooks/{flipbookId}/pages/{pageNumber}/image";
/**
 * Metadata for all the requests in the request builder.
 */
export const ImageRequestBuilderRequestsMetadata: RequestsMetadata = {
    put: {
        uriTemplate: ImageRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createFlipbookPagesResponseFromDiscriminatorValue,
        requestBodyContentType: "multipart/form-data",
        requestBodySerializer: serializeMultipartBody,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
